
define('ldsh!modules/client/item/template', [], function() {return function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape;
with (obj) {
__p += '<h1>Client</h1>\n<dl>\n  \n\t <dd>\n   <span name="first_name"></span>\n  </dd>\n  \n\t <dd>\n   <span name="last_name"></span>\n  </dd>\n  \n\t <dd>\n   <span name="organization"></span>\n  </dd>\n  \n\t <dd>\n   <span name="email"></span>\n  </dd>\n  \n\t <dd>\n   <span name="vat_name"></span>\n  </dd>\n  \n\t <dd>\n   <span name="vat_number"></span>\n  </dd>\n\n</dl>';

}
return __p
};});

